import React, { useMemo } from 'react';
import { Show } from 'components/shared/Show';
import { useFormikContext } from 'formik';
import { DateField, TimeField } from 'ui-toolkit';
import { getCurrentDate } from 'utilities/timeHelpers';
import { IDetailsFormData } from '../types/IDetailsFormData';
import { addDays, format } from 'date-fns';

export const RegularEventsTimeSelection: React.FC = () => {
  const { values } = useFormikContext<IDetailsFormData>();

  const getMinDate = useMemo(() => {
    const { isSignatureSyncAppointment, isDigitalScheduling } = values;

    if (isDigitalScheduling) {
      const tomorrow = format(addDays(new Date(), 1), 'yyyy-MM-dd');
      return tomorrow;
    }

    if (isSignatureSyncAppointment) {
      return getCurrentDate();
    }

    return undefined;
  }, [values]);

  return (
    <>
      {!values.isDateRange && (
        <div className="mb-2 flex gap-4">
          <Show when={!values.signerSelectsFromRange}>
            <DateField
              name="appointmentDate"
              label="Date"
              placeholder="Select a Date"
              isRequired={!values.signerSelectsFromRange}
              minDate={getMinDate}
            />
            <TimeField
              name="appointmentTime"
              label="Time"
              placeholder="0:00"
              isRequired={!values.signerSelectsFromRange}
            />
          </Show>
        </div>
      )}
    </>
  );
};
